module.exports = __webpack_public_path__ + "static/img/rbTygmeutGY26RXrngilafr8w.b204665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/originalframerhtml_files/rbTygmeutGY26RXrngilafr8w.png
// module id = lrHD
// module chunks = 62